export default "__VITE_ASSET__Bvf9JqxK__"